"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkplaceRoutes = void 0;
var WorkplaceRoutes;
(function (WorkplaceRoutes) {
    WorkplaceRoutes["BasePrefix"] = "workplaces";
    WorkplaceRoutes["Available"] = "available";
    WorkplaceRoutes["AvailableWithModules"] = "available/modules";
    WorkplaceRoutes["ById"] = ":workplaceId";
    WorkplaceRoutes["All"] = "all";
    WorkplaceRoutes["List"] = "list";
})(WorkplaceRoutes = exports.WorkplaceRoutes || (exports.WorkplaceRoutes = {}));
